import React from 'react'
import {useTranslation} from "react-i18next";

import useWorkgroupForm from "../workgroupForm/useWorkgroupForm";
import {useCreateWorkgroup} from "../query";

import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import Stack from "@mui/material/Stack";

import MDBox from "materialDashboard/components/MDBox";
import MDTypography from "materialDashboard/components/MDTypography";
import MDButton from "materialDashboard/components/MDButton";
import NameSection from "../workgroupForm/NameSection";


const WorkgroupCreate = () => {
    const {t} = useTranslation(['workgroups', 'validation']);

    const workgroupMutation = useCreateWorkgroup();

    const handleSubmit = async (data) => {
        await workgroupMutation.mutateAsync(data);
    }

    const {formik} = useWorkgroupForm({onSubmit: handleSubmit});


    return <Grid container justifyContent="center" alignItems="center" mt={4}>
        <Grid item xs={12} lg={8}>
            <Card>
                <MDBox
                    variant="gradient"
                    bgColor="info"
                    borderRadius="lg"
                    coloredShadow="info"
                    mx={2}
                    mt={-3}
                    p={2}
                    mb={1}
                    textAlign="center"
                >
                    <MDTypography variant="h4" fontWeight="medium" color="white" mt={1}>
                        {t('workgroupCreate.title')}
                    </MDTypography>
                </MDBox>

                <Stack direction="column" spacing={3} p={3}>
                    <NameSection formik={formik}/>

                    <Stack justifyContent="flex-end">
                        <MDButton variant="gradient" color="info" onClick={formik.handleSubmit} sx={{ml: "auto"}}>
                            {t('workgroupCreate.submit')}
                        </MDButton>
                    </Stack>
                </Stack>

            </Card>
        </Grid>
    </Grid>
}

export default WorkgroupCreate;